import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'idp-modify-mobile-skeleton-mach-core',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modify-mobile-skeleton-mach-core.component.html'
})
export class ModifyMobileSkeletonMachCoreComponent {}
